module.exports = __webpack_public_path__ + "media/31.b003d1c8.wav";